import React from 'react';

export const CloseModal = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.49123 5.49123C5.72564 5.25689 6.04352 5.12525 6.37498 5.12525C6.70643 5.12525 7.02432 5.25689 7.25873 5.49123L12 10.2325L16.7412 5.49123C16.8565 5.37184 16.9945 5.27661 17.147 5.2111C17.2995 5.14559 17.4635 5.11111 17.6295 5.10967C17.7955 5.10822 17.96 5.13985 18.1137 5.2027C18.2673 5.26555 18.4069 5.35837 18.5242 5.47574C18.6416 5.5931 18.7344 5.73267 18.7973 5.88629C18.8601 6.03991 18.8917 6.20451 18.8903 6.37048C18.8889 6.53646 18.8544 6.70048 18.7889 6.85298C18.7233 7.00549 18.6281 7.14342 18.5087 7.25873L13.7675 12L18.5087 16.7412C18.7364 16.977 18.8624 17.2927 18.8596 17.6205C18.8567 17.9482 18.7253 18.2617 18.4935 18.4935C18.2617 18.7253 17.9482 18.8567 17.6205 18.8596C17.2927 18.8624 16.977 18.7364 16.7412 18.5087L12 13.7675L7.25873 18.5087C7.02297 18.7364 6.70722 18.8624 6.37948 18.8596C6.05173 18.8567 5.73821 18.7253 5.50645 18.4935C5.27469 18.2617 5.14323 17.9482 5.14038 17.6205C5.13754 17.2927 5.26353 16.977 5.49123 16.7412L10.2325 12L5.49123 7.25873C5.25689 7.02432 5.12524 6.70643 5.12524 6.37498C5.12524 6.04352 5.25689 5.72564 5.49123 5.49123Z"
                fill="#252733"
            />
        </svg>
    );
};
